import type { ReactNode } from 'react';
import clsx from 'clsx';

export function FilterBar({ children }: { children: ReactNode }) {
  return (
    // Mobile (<sm): 3 fields per row (min 100px each) with no field-labels
    // so the block collapses to ~1/2 its previous height. Placeholders /
    // selected options carry the semantic. sm+ restores the labelled
    // flex-wrap layout with natural widths.
    <div
      // data-compact-filter opts inputs/selects here out of the global
      // 16px-min iOS-zoom guard (see src/styles/index.css) so the filter
      // fonts can match the 11px used elsewhere in the bar.
      data-compact-filter="true"
      className={
        // Tight 3-col filter grid on mobile with h-6 (24px) controls, 4px
        // padding + gap — fits ~5 fields in 2 rows (Search span-2 + one
        // slot on row 1, three dropdowns on row 2). Callers add
        // col-span-2/3 to override cell width. sm+ flips to natural-width
        // flex-wrap.
        'mb-2 grid grid-cols-3 items-end gap-1.5 rounded-card border border-[var(--border-color)] bg-[var(--card-bg)] p-1.5 backdrop-blur-xl sm:flex sm:flex-wrap sm:gap-3 sm:p-3 ' +
        '[&_input:not([type=checkbox]):not([type=radio])]:h-7 [&_input:not([type=checkbox]):not([type=radio])]:w-full [&_input:not([type=checkbox]):not([type=radio])]:px-2 [&_input:not([type=checkbox]):not([type=radio])]:py-0 [&_input:not([type=checkbox]):not([type=radio])]:text-xs sm:[&_input:not([type=checkbox]):not([type=radio])]:h-8 sm:[&_input:not([type=checkbox]):not([type=radio])]:w-full sm:[&_input:not([type=checkbox]):not([type=radio])]:px-2.5 sm:[&_input:not([type=checkbox]):not([type=radio])]:py-1 sm:[&_input:not([type=checkbox]):not([type=radio])]:text-xs ' +
        '[&_select]:h-7 [&_select]:w-full [&_select]:px-2 [&_select]:py-0 [&_select]:text-xs sm:[&_select]:h-8 sm:[&_select]:w-full sm:[&_select]:px-2.5 sm:[&_select]:py-1 sm:[&_select]:text-xs'
      }
    >
      {children}
    </div>
  );
}

export function FilterField({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  /** Optional width class, e.g. "w-44". Applied to the wrapper column. */
  className?: string;
}) {
  return (
    // Mobile (<sm): label hidden — placeholder/selected value carries the
    // semantic. Label re-appears at sm+ where there's room. `title` on the
    // wrapper preserves discoverability on mobile via a long-press tooltip.
    <div className={clsx('flex min-w-0 flex-col sm:flex-row sm:items-center sm:gap-2', className)} title={label}>
      <span className="hidden shrink-0 whitespace-nowrap text-[10px] font-bold uppercase tracking-wide text-[var(--text-muted)] sm:inline">
        {label}
      </span>
      <div className="min-w-0 sm:flex-1">{children}</div>
    </div>
  );
}
